import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const CheckBadgeIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m22.72 10.35l-1.84-1.48a1.09 1.09 0 0 1-.4-1l.25-2.34a2.09 2.09 0 0 0-2.3-2.31l-2.35.25a1.09 1.09 0 0 1-1-.4l-1.45-1.81a2.16 2.16 0 0 0-3.26 0L8.89 3.1a1.09 1.09 0 0 1-1 .4l-2.32-.25a2.09 2.09 0 0 0-2.3 2.31l.25 2.34a1.09 1.09 0 0 1-.4 1l-1.84 1.45a2.09 2.09 0 0 0 0 3.26l1.84 1.48a1.1 1.1 0 0 1 .4 1l-.25 2.35a2.07 2.07 0 0 0 .6 1.7a2 2 0 0 0 1.7.6l2.35-.25a1.09 1.09 0 0 1 1 .4l1.48 1.84a2.09 2.09 0 0 0 3.26 0l1.48-1.84a1.09 1.09 0 0 1 1-.4l2.35.25a2 2 0 0 0 1.7-.6a2.07 2.07 0 0 0 .6-1.7l-.25-2.35a1.1 1.1 0 0 1 .4-1l1.84-1.48a2.09 2.09 0 0 0 0-3.26Zm-10.32 4.7a1.79 1.79 0 0 1-2.67.19L7.29 12.8a1 1 0 1 1 1.42-1.42L11 13.63l3.91-5.21a1 1 0 0 1 1.6 1.2Z"
      />
    </svg>
  );
};

export default CheckBadgeIcon;
